import { render, staticRenderFns } from "./PopupAIRiskRecommendation.vue?vue&type=template&id=2198079c&scoped=true"
import script from "./PopupAIRiskRecommendation.vue?vue&type=script&lang=js"
export * from "./PopupAIRiskRecommendation.vue?vue&type=script&lang=js"
import style0 from "./PopupAIRiskRecommendation.vue?vue&type=style&index=0&id=2198079c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198079c",
  null
  
)

export default component.exports